import React from 'react';
import PropTypes from 'prop-types';

/**
 * UserSearch - Search bar for finding users
 *
 * @param {Object} props
 * @param {string} props.searchUsername - Current search value
 * @param {Function} props.onSearchChange - Search value change handler
 * @param {Function} props.onSearch - Search submit handler
 */
const UserSearch = ({ searchUsername, onSearchChange, onSearch }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="section-card">
      <h2>Search User</h2>
      <div className="search-bar">
        <input
          type="text"
          placeholder="Enter username to search..."
          value={searchUsername}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyPress={handleKeyPress}
          className="search-input"
        />
        <button className="btn-primary" onClick={onSearch}>
          Search
        </button>
      </div>
    </div>
  );
};

UserSearch.propTypes = {
  searchUsername: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default UserSearch;
